import { ToastrService } from 'ngx-toastr';
import { WithTitle } from 'projects/mypay4-fe-common/src/lib/components/with-title';
import { manageError, OverlaySpinnerService } from 'projects/mypay4-fe-common/src/public-api';
import { Subscription } from 'rxjs';

import { Location } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';

import { Ente } from '../../model/ente';
import { FlussoRicevuta } from '../../model/flusso-ricevuta';
import { AccertamentoService } from '../../services/accertamento.service';
import { EnteService } from '../../services/ente.service';

@Component({
  selector: 'app-accertamenti-dettaglio-cruscotto',
  templateUrl: './accertamenti-dettaglio-cruscotto.component.html',
  styleUrls: ['./accertamenti-dettaglio-cruscotto.component.scss']
})
export class AccertamentiDettaglioCruscottoComponent implements OnInit, WithTitle {

  get titleLabel(){ return "Dettaglio RT" }
  get titleIcon(){ return faBriefcase }

  private enteChangesSub: Subscription;
  ente: Ente;
  flussoRicevuta = new FlussoRicevuta();
  codTipo: string;
  codIud: string;
  pagatore: string;
  versante: string;

  constructor(
    private enteService: EnteService,
    private accertamentoService: AccertamentoService,
    private overlaySpinnerService: OverlaySpinnerService,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.enteChangesSub = this.enteService.getCurrentEnteObs().subscribe(ente => {
      this.ente = ente;
      const spinner = this.overlaySpinnerService.showProgress(this.elementRef);
      this.route.queryParams.subscribe(params => {
        this.codTipo = params['codTipo'];
        this.codIud = params['codIud'];
        this.accertamentoService.getRicevuteTelematiche(ente, this.codTipo, this.codIud).subscribe(ricevute => {
          this.flussoRicevuta = ricevute[0] || new FlussoRicevuta();
          this.overlaySpinnerService.detach(spinner);
        }, manageError('Errore caricando la RT', this.toastrService, () => {this.overlaySpinnerService.detach(spinner)}) );
      });
    });
  }

  ngOnDestroy():void {
    this.enteChangesSub?.unsubscribe();
  }

  goBack() {
    this.location.back();
  }

}
